// Adjusts the font size of the header title inside of the header block based on the length of its content, specifically targeting mobile screen sizes.

const mobileFontSizeAdjustment = () => {
	if(window.innerWidth > 768) return;

	const headerTitle = document.getElementById("header-title");
	const mainWidth = document.querySelector(".default-content-body")?.offsetWidth;
	const headerTitleWidth = headerTitle?.offsetWidth;

	// Calculate the difference between mainWidth and headerTitleWidth
	const widthDifference = mainWidth - headerTitleWidth;

	if (widthDifference < 0) {
		// Only adjust font size if headerTitleWidth exceeds mainWidth
		const ratio =  mainWidth / headerTitleWidth;

		const baseFontSize = 37;
		const newFontSize = baseFontSize * (ratio);

		headerTitle.style.fontSize = `${newFontSize}px`; // You can adjust the units as needed
	}
};

export default mobileFontSizeAdjustment;
